import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { AenaHome } from '../aena/home'
import { PetAdd } from './pet/add'
import { PetEdit as AenaPetEdit } from './pet/edit'
import PassportAena from '../aena/passport'
import AenaDocuments from '../aena/passport/documents'
import AenaVaccines from '../aena/passport/vaccines'
import AenaAddVaccines from './passport/vaccines/add'
import { VaccineHistoryPage as AenaVaccineHistory } from './passport/vaccines/history'
import AenaInsurance from '../aena/passport/insurance'
import AenaExternalInsuranceAdd from './passport/insurance/addexternal'
import AenaExternalInsuranceEdit from './passport/insurance/editexternal'
import AenaSos from '../aena/sos'
import { SosMap as AenaSosMap } from '../aena/sos/history/map'
import { SosHistory as AenaSosHistory } from '../aena/sos/history'
import AenaSosSelectLocation from '../aena/sos/select-location'
import AenaOwnerEdit from './owner/edit'
import AenaVetChat from '../aena/vetchat'
import AenaTravelList from '../aena/travel/list'
import AenaTravelAdd from '../aena/travel/add'
import AenaTravelDetail from '../aena/travel/detail'
import AenaTravelEdit from '../aena/travel/edit'
import AenaTravelBoarding from '../aena/travel/boarding'
import AenaTravelDocs from '../aena/travel-docs'
import AenaAirlinePanel from '../aena/airlines'

const ServicesGroup: React.FC = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="home" element={<AenaHome />} />
        <Route path="pet/add" element={<PetAdd />} />
        <Route path="pet/edit" element={<AenaPetEdit />} />
        <Route path="pet/owner/edit" element={<AenaOwnerEdit />} />
        <Route path="passport" element={<PassportAena />} />
        <Route path="passport/documents" element={<AenaDocuments mode="national" />} />
        <Route path="passport/exterior" element={<AenaDocuments mode="exterior" />} />
        <Route path="passport/vaccines" element={<AenaVaccines />} />
        <Route path="passport/vaccines/add" element={<AenaAddVaccines />} />
        <Route path="passport/vaccines/history" element={<AenaVaccineHistory />} />
        <Route path="passport/insurance" element={<AenaInsurance />} />
        <Route path="passport/insurance/addexternal" element={<AenaExternalInsuranceAdd />} />
        <Route path="passport/insurance/editexternal" element={<AenaExternalInsuranceEdit />} />
        <Route path="sos" element={<AenaSos />} />
        <Route path="sos/history/map" element={<AenaSosMap />} />
        <Route path="sos/history" element={<AenaSosHistory />} />
        <Route path="sos/selectlocation" element={<AenaSosSelectLocation />} />
        <Route path="travel" element={<AenaTravelList />} />
        <Route path="travel-docs" element={<AenaTravelDocs />} />
        <Route path="aerolineas" element={<AenaAirlinePanel />} />
        <Route path="vetchat" element={<AenaVetChat />} />
        <Route path="travel/add" element={<AenaTravelAdd />} />
        <Route path="travel/detail/:travelId" element={<AenaTravelDetail />} />
        <Route path="travel/:travelId/edit" element={<AenaTravelEdit />} />
        <Route path="travel/:travelId/boarding" element={<AenaTravelBoarding />} />
        {/* <Route path="travel/list" element={<AenaTravelList />} /> */}
      </Routes>
    </React.Fragment>
  )
}

export default ServicesGroup
